var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3998_1544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9695 24C24.272 24.0004 24.563 24.1305 24.783 24.3638C25.003 24.5971 25.1353 24.9159 25.1531 25.2552C25.1708 25.5944 25.0725 25.9285 24.8784 26.1891C24.6842 26.4497 24.4088 26.6172 24.1084 26.6573L23.9695 26.6667H4.97885C4.67633 26.6663 4.38535 26.5362 4.16537 26.3029C3.94539 26.0696 3.81302 25.7507 3.79529 25.4115C3.77756 25.0722 3.87582 24.7382 4.06998 24.4776C4.26415 24.2169 4.53957 24.0495 4.83998 24.0093L4.97885 24H23.9695ZM23.9695 14.6667C24.2843 14.6667 24.5862 14.8071 24.8088 15.0572C25.0314 15.3072 25.1564 15.6464 25.1564 16C25.1564 16.3536 25.0314 16.6928 24.8088 16.9428C24.5862 17.1929 24.2843 17.3333 23.9695 17.3333H4.97885C4.66406 17.3333 4.36216 17.1929 4.13957 16.9428C3.91698 16.6928 3.79193 16.3536 3.79193 16C3.79193 15.6464 3.91698 15.3072 4.13957 15.0572C4.36216 14.8071 4.66406 14.6667 4.97885 14.6667H23.9695ZM23.9695 5.33333C24.2843 5.33333 24.5862 5.47381 24.8088 5.72386C25.0314 5.97391 25.1564 6.31304 25.1564 6.66667C25.1564 7.02029 25.0314 7.35943 24.8088 7.60947C24.5862 7.85952 24.2843 8 23.9695 8H4.97885C4.66406 8 4.36216 7.85952 4.13957 7.60947C3.91698 7.35943 3.79193 7.02029 3.79193 6.66667C3.79193 6.31304 3.91698 5.97391 4.13957 5.72386C4.36216 5.47381 4.66406 5.33333 4.97885 5.33333H23.9695Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3998_1544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.486,
    height: 32,
    fill: "white",
    transform: "translate(0.231201)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLine);
export default __webpack_public_path__ + "static/media/menu-line.fe1eb6909dea778f562e607dd4d7571f.svg";
export { ForwardRef as ReactComponent };